import { ClientHash, OrderUser } from '../types';

export const whoCanSeeOrder = (
    user: OrderUser,
    customerID: number,
    clientHash: ClientHash,
    isSellerSeeAllOrders: boolean,
): boolean => {
    const rights = user.rights;
    const isShowAll =
        rights?.includes('ADMIN') ||
        rights?.includes('OFFICE') ||
        rights?.includes('DEV');

    if (isShowAll) return true;

    if (rights.includes('CUSTOMER')) {
        return +user.code_internal === customerID;
    }
    if (rights.includes('SELLER')) {
        if (isSellerSeeAllOrders) return true;
        return clientHash[customerID]?.ResellerID === +user.code_internal;
    }
    return false;
};
